import styled from 'styled-components';
import { Pagination } from '@mui/material';

export default styled(Pagination)`
  display: flex;
  justify-content: center;
  margin: 20px;
`;
